import { mods } from '@approvalmax/theme';
import { font, NumberEditor } from '@approvalmax/ui';
import { StyledMods } from '@styled-kit/mods';
import styled from 'styled-components';

import { WithVariant } from './CurrencyExchangeRateInput.types';

export const Root = styled.div<StyledMods<WithVariant>>`
    display: flex;
    align-items: center;
    ${font(13)}

    ${mods('variant', 'field')`
        flex-direction: column;
        align-items: flex-start;
    `}
`;

export const BaseCurrency = styled.div<StyledMods<WithVariant>>`
    margin-right: 5px;
    white-space: nowrap;
    ${font(14, '#000')}

    ${mods('variant', 'field')`
        margin-right: 0;
        margin-bottom: 5px;
        ${font(12, '#5e5c5c', 'semibold')}
    `}
`;

export const InputWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`;

export const StyledNumberEditor = styled(NumberEditor)<StyledMods<WithVariant>>`
    width: 130px;
    padding-right: 48px;

    ${mods('variant', 'field')`
        width: 90px;
        padding-right: 3px;
    `}
`;

export const SelectedCurrencyWrapper = styled.div<StyledMods<WithVariant>>`
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    ${font(13, '#000')}

    ${mods('variant', 'field')`
        position: initial;
        margin-left: 10px;
        transform: none;
        ${font(14, '#7f7d7d')}
    `}
`;
